import { useCallback, useRef } from 'react';

import { trackSelectItemGA, trackSelectModifyServiceGA, trackViewItemListGA } from '@telialt/gtm-tracking/src/events';
import { isSSR } from '@telialt/utils/src/helpers';
import { useUserDataQueryBase } from '@telialt/utils/src/SSO/useUserData';

import { ServiceOfferItem } from '../model';

export const usePlansGA = () => {
    const { isLoadingUserData, userData } = useUserDataQueryBase({ isEnabled: !isSSR() });

    const userDataRef = useRef(userData);
    userDataRef.current = userData;

    const onViewItemList = useCallback((services: ServiceOfferItem[]) => {
        trackViewItemListGA({ source: 'publicServicePlans', data: { userData: userDataRef.current, plans: services } });
    }, []);

    const onSelectItem = useCallback((service: ServiceOfferItem, index: number) => {
        trackSelectItemGA({
            source: 'publicServicePlans',
            data: { userData: userDataRef.current, plans: [service], index },
        });
    }, []);

    const onSelectModifyService = useCallback((service: ServiceOfferItem, index: number) => {
        trackSelectModifyServiceGA({
            source: 'publicServicePlans',
            data: { userData: userDataRef.current, plans: [service], index },
        });
    }, []);

    return {
        isLoading: isLoadingUserData,
        onViewItemList,
        onSelectItem,
        onSelectModifyService,
    };
};
